import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { PaymentSchedule, PurchaseOrder } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0680. 支払予定一覧
 * [GET] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_schedules
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
};
const paymentSchedules = (props: Props): Promise<PaymentSchedule[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.id}/payment_schedules`);
};

export const usePaymentSchedules = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'teams', props.team_id, 'purchase_orders', props.id, 'payment_schedules'],
    queryFn: () => paymentSchedules(props),
  });
};

export const usePaymentSchedulesInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ['workspaces', props.identifier, 'teams', props.team_id, 'purchase_orders', props.id, 'payment_schedules'] });
  };

  return { invalidate };
};
